import { UploadOutlined } from '@ant-design/icons';
import { BaseForm } from '@app/components/common/forms/BaseForm/BaseForm';
import * as Auth from '@app/components/layouts/AuthLayout/AuthLayout.styles';
import { IFile } from '@app/interfaces/file';
import { ANY_OBJECT } from '@app/interfaces/interfaces';
import { getReadableFileName, normFile } from '@app/utils/utils';
import { Button, Input, UploadFile, UploadProps } from 'antd';
import Upload from 'antd/lib/upload';
import mime from 'mime-types';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './AddFileForm.styles';
import { handlePreview } from '@app/utils/file';

interface AddFileFormProps {
  file: IFile | null;
  loading: boolean;
  onFinish: (data: ANY_OBJECT) => void;
}

export const AddFileForm: React.FC<AddFileFormProps> = ({ loading, onFinish, file }) => {
  const { t } = useTranslation();
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const [form] = BaseForm.useForm();

  const props: UploadProps = {
    maxCount: 1,
    multiple: false,
    showUploadList: true,
    method: 'POST',
    listType: 'picture',
    fileList,
    beforeUpload: (file) => {
      const isImage = file.type === 'image/*';
      return isImage;
    },
    isImageUrl: () => {
      return false;
    },
    onChange: (info) => {
      setFileList(info.fileList);
    },
    onPreview: handlePreview,
  };

  useEffect(() => {
    if (file) {
      form.setFieldsValue({ description: file.description });
      form.setFieldsValue({
        file: [
          {
            uid: file.id,
            name: getReadableFileName(file.originalName as string),
            url: file.originalName,
            type: file.originalName ? mime.lookup(file.originalName) : '',
            showPreviewIcon: false,
          },
        ],
      });
    } else {
      form.resetFields();
    }
  }, [file, form]);

  return (
    <BaseForm form={form} name="roleForm" onFinish={onFinish} validateTrigger="onBlur">
      <S.ContentWrapper>
        <S.BlockWrapper>
          <S.Label> {t('files.form.addFile')}</S.Label>
          <Auth.FormItem
            name="file"
            label={t('files.form.file')}
            hasFeedback
            valuePropName="fileList"
            getValueFromEvent={normFile}
            rules={[{ required: true, message: t('files.form.fileRequired') }]}
          >
            <Upload name="files" {...props}>
              <Button type="default" icon={<UploadOutlined />}>
                {t('files.form.clickToUpload')}
              </Button>
            </Upload>
          </Auth.FormItem>
          <Auth.FormItem name="description" label={t('files.form.description')} hasFeedback>
            <Input placeholder={t('files.form.description')} />
          </Auth.FormItem>
        </S.BlockWrapper>
        <BaseForm.Item>
          <Button type="primary" htmlType="submit" block disabled={loading}>
            {t('common.save')}
          </Button>
        </BaseForm.Item>
      </S.ContentWrapper>
    </BaseForm>
  );
};
